var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { environment } from '@env/environment';
import * as i0 from "@angular/core";
var GooglePlacesService = /** @class */ (function () {
    function GooglePlacesService() {
        this._service = new google.maps.places.AutocompleteService();
        this.config = environment;
    }
    /**
     *  Find place by given query
     * @param query Direction to find
     */
    GooglePlacesService.prototype.findDiection = function (query) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this._service.getPlacePredictions({
                            input: query,
                            componentRestrictions: {
                                country: _this.config.enabledCountries
                            }
                        }, function (predictions, status) {
                            if (status !== google.maps.places.PlacesServiceStatus.OK)
                                return resolve([]);
                            console.log('1', predictions);
                            var results = predictions.map(function (prediction) {
                                var _item = {
                                    value: prediction.structured_formatting.main_text ?
                                        prediction.structured_formatting.main_text : prediction.structured_formatting.secondary_text,
                                    address: prediction.structured_formatting.secondary_text,
                                    place_id: prediction.place_id
                                };
                                return _item;
                            });
                            return resolve(results);
                        });
                    })];
            });
        });
    };
    GooglePlacesService.ngInjectableDef = i0.defineInjectable({ factory: function GooglePlacesService_Factory() { return new GooglePlacesService(); }, token: GooglePlacesService, providedIn: "root" });
    return GooglePlacesService;
}());
export { GooglePlacesService };
